import React from "react";
import { SelectChangeEvent } from "@mui/material";
import { ChangeQtyFn } from "./QuantityUpdate";

function useQtyUpdateSelector(changeQuantity: ChangeQtyFn, unitId: string) {
  const handleChange = (event: SelectChangeEvent<number | string>) => {
    const { value } = event.target;
    changeQuantity(unitId, value);
  };

  const qtyOptions = Array.from({ length: 20 }, (x, i) => i + 1);

  return {
    handleChange,
    qtyOptions,
  };
}

export default useQtyUpdateSelector;
